import type { TARSChartConfiguration } from "./tarsBarChartHelpers";
import {
  TARS_AXIS_LABEL_FONT_SIZE_PX,
  TARS_DATA_LABEL_FONT_SIZE_PX,
} from "./tars-chart-column-style";

export const TARS_TITLE_FONT_SIZE_PX = 18;
export const CHART_CONFIG_TITLE_FONT_SIZE_DEFAULT = TARS_TITLE_FONT_SIZE_PX;

export type TarsChartFontSizes = {
  title: number;
  axis: number;
  dataLabel: number;
};

const FONT_SIZE_MIN_PX = 8;
const FONT_SIZE_MAX_PX = 72;

function clampFontSize(value: unknown, fallback: number): number {
  if (typeof value !== "number" || !Number.isFinite(value)) return fallback;
  return Math.min(FONT_SIZE_MAX_PX, Math.max(FONT_SIZE_MIN_PX, value));
}

export function resolveTarsChartFontSizes(
  configuration?: TARSChartConfiguration
): TarsChartFontSizes {
  return {
    title: clampFontSize(configuration?.titleFontSize, TARS_TITLE_FONT_SIZE_PX),
    axis: clampFontSize(configuration?.axisFontSize, TARS_AXIS_LABEL_FONT_SIZE_PX),
    dataLabel: clampFontSize(configuration?.dataLabelFontSize, TARS_DATA_LABEL_FONT_SIZE_PX),
  };
}
